import { createClient } from '@supabase/supabase-js';
import { cloudSupabaseConfig } from '../config/supabaseInstances';

/** Cloud Supabase — authentication and public schema (user_roles, etc.). */
const supabase = createClient(cloudSupabaseConfig.url, cloudSupabaseConfig.anonKey);

export default supabase;
